import { actions } from './actions'

const initialState = {
  estados: {
    data: [],
    loading: false,
    error: '',
  },
  estadosMensajeria: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function estadosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ESTADOS_LOAD_REQUESTED:
      return {
        ...state,
        estados: { ...state.estados, loading: true },
      }
    case actions.ESTADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        estados: { ...state.estados, data: action.payload, loading: false },
      }
    case actions.ESTADOS_LOAD_FILED:
      return {
        ...state,
        estados: { ...state.estados, loading: false, error: action.error },
      }

    case actions.ESTADOS_MENSAJERIA_LOAD_REQUESTED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: true },
      }
    case actions.ESTADOS_MENSAJERIA_LOAD_SUCCEEDED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, data: action.payload, loading: false },
      }
    case actions.ESTADOS_MENSAJERIA_LOAD_FILED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: false, error: action.error },
      }
    case actions.ESTADO_UPDATE_REQUESTED:
      return {
        ...state,
        estados: { ...state.estados, loading: true, error: '' },
      }
    case actions.ESTADO_UPDATE_SUCCEEDED:
      return {
        ...state,
        estados: {
          ...state.estados,
          data: state.estados.data.map(estado =>
            estado.id === action.payload.id ? action.payload : estado,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_UPDATE_FILED:
      return {
        ...state,
        estados: { ...state.estados, loading: false, error: action.error },
      }
    case actions.ESTADO_INSERT_REQUESTED:
      return {
        ...state,
        estados: { ...state.estados, loading: true, error: '' },
      }
    case actions.ESTADO_INSERT_SUCCEEDED:
      return {
        ...state,
        estados: {
          ...state.estados,
          data: [].concat(action.payload, state.estados.data),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_INSERT_FILED:
      return {
        ...state,
        estados: { ...state.estados, loading: false, error: action.error },
      }
    case actions.ESTADO_DELETE_REQUESTED:
      return {
        ...state,
        estados: { ...state.estados, loading: true, error: '' },
      }
    case actions.ESTADO_DELETE_SUCCEEDED:
      return {
        ...state,
        estados: {
          ...state.estados,
          data: state.estados.data.filter(estado => estado.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_DELETE_FILED:
      return {
        ...state,
        estados: { ...state.estados, loading: false, error: action.error },
      }

    case actions.ESTADO_MENSAJERIA_UPDATE_REQUESTED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: true, error: '' },
      }
    case actions.ESTADO_MENSAJERIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        estadosMensajeria: {
          ...state.estadosMensajeria,
          data: state.estadosMensajeria.data.map(estado =>
            estado.id === action.payload.id ? action.payload : estado,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_MENSAJERIA_UPDATE_FILED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: false, error: action.error },
      }
    case actions.ESTADO_MENSAJERIA_INSERT_REQUESTED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: true, error: '' },
      }
    case actions.ESTADO_MENSAJERIA_INSERT_SUCCEEDED:
      return {
        ...state,
        estadosMensajeria: {
          ...state.estadosMensajeria,
          data: [].concat(action.payload, state.estadosMensajeria.data),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_MENSAJERIA_INSERT_FILED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: false, error: action.error },
      }
    case actions.ESTADO_MENSAJERIA_DELETE_REQUESTED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: true, error: '' },
      }
    case actions.ESTADO_MENSAJERIA_DELETE_SUCCEEDED:
      return {
        ...state,
        estadosMensajeria: {
          ...state.estadosMensajeria,
          data: state.estadosMensajeria.data.filter(estado => estado.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADO_MENSAJERIA_DELETE_FILED:
      return {
        ...state,
        estadosMensajeria: { ...state.estadosMensajeria, loading: false, error: action.error },
      }

    default:
      return state
  }
}
